import { useEffect, useState } from 'react';
import { getAdStatus, getAdStatusByOps } from 'api/marketing';

interface AdStatus {
    hasJoinedAdSystem: boolean;
    joinedAt: string;
}

const useAdStatus = (isOps?: boolean, providerId?: number): [AdStatus, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<AdStatus>({
        hasJoinedAdSystem: true,
        joinedAt: '',
    });

    const fetchData = async () => {
        if (isOps && !providerId) return;
        try {
            setLoading(true);
            const result = isOps ? await getAdStatusByOps(providerId!) : await getAdStatus();
            if (!result.error) {
                const data: AdStatus = result?.data?.data || false;
                setStatus(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [isOps, providerId]);

    return [status, loading, fetchData];
};

export default useAdStatus;
